// extracted by mini-css-extract-plugin
module.exports = {"subMenu":"style_subMenu__338JF","item":"style_item__4BxT2"};